// Adding a file to an email box's attachments (2026-10-08): read it as a data
// URL and refuse it when the box's images and attachments together would pass
// the one-email size cap. Shared by the reply box (SuggestionPanel.jsx) and the
// New view; the server re-checks the same cap before any send.
import { estimateBase64Bytes, estimateInlineImageBytes, MAX_EMAIL_ATTACHMENT_BYTES } from './richTextConversion.js'

export function attachmentsBytes(attachments) {
  return (attachments ?? []).reduce((sum, a) => sum + estimateBase64Bytes((a.dataUrl ?? '').split(',')[1] ?? ''), 0)
}

// The refusal for a file of newBytes, or null when it fits.
export function attachmentCapError({ attachments = [], bodyHtml = '', newBytes = 0 } = {}) {
  const currentTotal = attachmentsBytes(attachments) + estimateInlineImageBytes(bodyHtml)
  if (currentTotal + newBytes <= MAX_EMAIL_ATTACHMENT_BYTES) return null
  return `This file would push the combined size of images/attachments over the ${(MAX_EMAIL_ATTACHMENT_BYTES / (1024 * 1024)).toFixed(0)}MB limit for one reply — remove something first.`
}

// Resolves { attachment } or { error }. Browser only (FileReader).
export function readEmailAttachmentFile(file, { attachments = [], bodyHtml = '' } = {}) {
  return new Promise((resolve) => {
    const reader = new FileReader()
    reader.onload = () => {
      const dataUrl = reader.result
      const error = attachmentCapError({ attachments, bodyHtml, newBytes: estimateBase64Bytes(String(dataUrl).split(',')[1] ?? '') })
      if (error) { resolve({ error }); return }
      resolve({ attachment: { id: `${Date.now()}-${Math.random()}`, file, name: file.name, size: file.size, dataUrl } })
    }
    reader.onerror = () => resolve({ error: `Could not read ${file.name}.` })
    reader.readAsDataURL(file)
  })
}
